import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface Props {
  totalStars: number;
  totalScore: number;
  totalActivities: number;
}

const BADGES = [
  { id: "first", emoji: "🌱", label: "أول نشاط", condition: (a: number) => a >= 1 },
  { id: "five", emoji: "⭐", label: "5 أنشطة", condition: (a: number) => a >= 5 },
  { id: "ten", emoji: "🏅", label: "10 أنشطة", condition: (a: number) => a >= 10 },
  { id: "twenty", emoji: "🎖️", label: "20 نشاط", condition: (a: number) => a >= 20 },
  { id: "fifty", emoji: "👑", label: "50 نشاط", condition: (a: number) => a >= 50 },
];

const LEVELS = [
  { min: 0, label: "مبتدئ", emoji: "🌱", color: "bg-green-100 text-green-700" },
  { min: 30, label: "نشيط", emoji: "🔥", color: "bg-orange-100 text-orange-700" },
  { min: 80, label: "بطل", emoji: "🏆", color: "bg-blue-100 text-blue-700" },
  { min: 150, label: "نجم", emoji: "⭐", color: "bg-yellow-100 text-yellow-700" },
];

export function getLevel(score: number) {
  let level = LEVELS[0];
  for (const l of LEVELS) {
    if (score >= l.min) level = l;
  }
  return level;
}

export default function AchievementBadges({ totalStars, totalScore, totalActivities }: Props) {
  const level = getLevel(totalScore);
  const earnedBadges = BADGES.filter(b => b.condition(totalActivities));

  return (
    <Card className="border-2 border-amber-200 bg-gradient-to-br from-amber-50 to-yellow-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          🏆 الشارات والمستوى
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Level */}
        <div className="flex items-center gap-3 p-3 rounded-xl bg-card border">
          <span className="text-3xl">{level.emoji}</span>
          <div>
            <p className="text-sm text-muted-foreground">المستوى الحالي</p>
            <Badge className={level.color}>{level.label}</Badge>
          </div>
          <div className="mr-auto text-left">
            <p className="text-xs text-muted-foreground">{totalScore} نقطة</p>
            <p className="text-xs text-muted-foreground">{totalStars} ⭐</p>
          </div>
        </div>

        {/* Badges */}
        <div className="grid grid-cols-5 gap-2">
          {BADGES.map(b => {
            const earned = b.condition(totalActivities);
            return (
              <div
                key={b.id}
                className={`text-center p-2 rounded-xl border transition-all ${
                  earned
                    ? "bg-amber-50 border-amber-300 animate-scale-in"
                    : "bg-muted/30 border-muted opacity-40 grayscale"
                }`}
              >
                <div className="text-2xl">{b.emoji}</div>
                <p className="text-[10px] mt-1 font-medium text-foreground">{b.label}</p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
